import {Component, Input} from "@angular/core";

/**
 * Loading spinner that fits in the page footers
 */
@Component({
    selector: "wbo-footer-spinner",
    templateUrl: "./footer-spinner.component.html"
})
export class FooterSpinnerComponent {

    /**
     * i18n label
     */
    @Input() label: string;

    /**
     * Indicates that the spinner should be shown
     */
    @Input() processing: boolean;

}
